import { ProductItemSkeleton } from 'components/Blocks/Product/List/ListedItem/ProductItemSkeleton';
import { CSSProperties } from 'react';
import { ProductRecommendationAreaType } from 'types/productRecommendationArea';
import twMerge from 'utils/twMerge';

type ProductRecommendationAreasSkeletonProps = {
    productRecommendationAreas: ProductRecommendationAreaType[];
    maxVisibleItems?: number;
    productSliderClassName?: string;
};

export const ProductRecommendationAreasSkeleton: FC<ProductRecommendationAreasSkeletonProps> = ({
    productRecommendationAreas,
    maxVisibleItems,
    productSliderClassName,
}) => {
    const getSliderItemWidthDivisor = (defaultValue: number) =>
        maxVisibleItems ? Math.min(maxVisibleItems, defaultValue) : defaultValue;

    return (
        <div className="flex flex-col gap-y-4 pt-2">
            {productRecommendationAreas.map((productRecommendationArea, areaIndex) => {
                if (productRecommendationArea.area.externalSourceDivId) {
                    return <div key={areaIndex} id={productRecommendationArea.area.externalSourceDivId} />;
                }

                const productCount = Math.min(
                    productRecommendationArea.products.length,
                    productRecommendationArea.area.maximumLoadedProductCount,
                );

                if (productCount === 0) {
                    return null;
                }

                return (
                    <div key={areaIndex}>
                        <h3 className="mb-0 lg:mb-0">{productRecommendationArea.area.header}</h3>
                        <div
                            className={twMerge(
                                'relative h-[475px] min-w-full overflow-hidden py-4 lg:h-[540px] vl:h-[550px]',
                                productSliderClassName,
                            )}
                        >
                            <div className="relative flex h-full w-full">
                                {Array.from({ length: productCount }, (_, productIndex) => (
                                    <div
                                        key={productIndex}
                                        className="w-[calc(100%-120px)] flex-shrink-0 px-2 md:w-[calc(100%/var(--len-md))] lg:w-[calc(100%/var(--len-lg))] vl:w-[calc(100%/var(--len-vl))] xl:w-[calc(100%/var(--len-xl))]"
                                        style={
                                            {
                                                '--len-md': getSliderItemWidthDivisor(2),
                                                '--len-lg': getSliderItemWidthDivisor(3),
                                                '--len-vl': getSliderItemWidthDivisor(4),
                                                '--len-xl': getSliderItemWidthDivisor(5),
                                            } as CSSProperties
                                        }
                                    >
                                        <ProductItemSkeleton className="h-full border-0" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
